import request from '../../services/request'

export default class DomainEvent {
  fire(params) {
    request.post(this.url, params)
  }
}
